import type { BlockResult } from '@/types/blocker'
import type { LevelWithUnderscores } from '@/types/journey'

import type { LevelUiStatus } from '../constants/status'

type LevelStatusInput = {
  level: LevelWithUnderscores
  blockResult: BlockResult
  currentLevelUid: string | undefined
}

export const getLevelUiStatus = ({
  level,
  blockResult,
  currentLevelUid
}: LevelStatusInput): LevelUiStatus => {
  if (!blockResult.unlocked) return 'locked'
  if (level._progress?.finished) return 'success'
  if (level.uid === currentLevelUid) return 'progress'
  return 'available'
}

/** Nível concluído em jornada com `block_redo`: o bloqueio vem só de não
 *  poder refazer — o `blockRedo` só fica pendente depois que o progresso marca
 *  o nível como concluído. Não é pendência de requisito, é estado final.
 *  Com outra condição pendente junto (data, nível exigido) é falso: a dica e o
 *  aviso do card falam dessa outra condição, e o card fica como antes. */
export const isLevelRedoLocked = (blockResult: BlockResult): boolean =>
  blockResult.unmet.length > 0 &&
  blockResult.unmet.every(
    blocker => blocker.type === 'resource' && blocker.condition === 'blockRedo'
  )
